import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReduxState } from "../../../redux";
import { closeModal } from "../../../redux/reducers/ModalManager";
import SandboxReadOnlyModal from "./SandboxReadOnlyModal";

const SandboxReadOnlyModalManager: React.FC = () => {
  const dispatch = useDispatch();
  const { activeModal } = useSelector((state: ReduxState) => state.ModalManager);

  const handleHide = () => dispatch(closeModal("sandboxReadOnly"));

  return (
    <SandboxReadOnlyModal
      show={activeModal === "sandboxReadOnly"}
      onHide={handleHide}
    />
  );
};

export default SandboxReadOnlyModalManager;
